let animationsZone2 = {
    sliderAndPlane: () => {

        // vars
        let sliderLine = ".sliderLine",
            thePlane = ".thePlane",
            tl = new TimelineLite({
                onComplete: complete,
                onCompleteParams: ['{self}']
            }),
            tl2 = new TimelineLite({
                onComplete: complete,
                onCompleteParams: ['{self}']
            });

        tl.to(sliderLine, 1, {
                y: -10,
                ease: Elastic.easeOut.config(1, 0.3)
            })
            .to(sliderLine, 1.5, {
                y: 40,
                ease: Elastic.easeOut.config(1, 0.3)
            })
            .to(sliderLine, 1, {
                y: 20,
                ease: Elastic.easeOut.config(1, 0.3)
            })
            .to(sliderLine, 0.6, {
                y: 0,
                ease: Elastic.easeOut.config(1, 0.3)
            });

        tl2.to(thePlane, 1.5, {
                y: -180,
                scale: 0.95,
                ease: Power1.easeOut
            }).to(thePlane, 0.5, {
                rotation: -180,
                x: -10,
                scale: 0.80,
                skewY: "60deg"
            }, "-=0.4")
            .to(thePlane, 0.2, {
                skewY: "0deg"
            })
            .to(thePlane, 1.5, {
                y: 120,
                ease: Power1.easeOut
            }, "-=0.2")
            .to(thePlane, 0.5, {
                rotation: -360,
                x: 0,
                skewY: "-10deg"
            })
            .to(thePlane, 0.2, {
                skewY: "0deg"
            })
            .to(thePlane, 0.8, {
                y: 0,
                scale: 1,
                ease: Power1.easeOut
            });


        function complete(tl) {
            setTimeout(() => {
                tl.restart();
            }, 1000);
        }
    },

    searchIcon: () => {

        // vars
        let searchIcon = ".searchIcon",
            hotelIcon = ".hotelIcon",
            tl = new TimelineLite({
                onComplete: complete,
                onCompleteParams: ['{self}']
            });

        tl.set(searchIcon, {
                rotation: 15,
                scale: 0.8,
                transformOrigin: "center"
            })
            .to(searchIcon, 1, {
                rotation: 0,
                scale: 1,
                transformOrigin: "center"
            })
            .to(hotelIcon, 1, {
                scale: 0.8,
                transformOrigin: "center"
            }, "-=1")
            .to(searchIcon, 1, {
                rotation: 15,
                scale: 0.8,
                transformOrigin: "center"
            })
            .to(hotelIcon, 1, {
                scale: 1,
                transformOrigin: "center"
            }, "-=1");

        function complete(tl) {
            setTimeout(() => {
                tl.restart();
            }, 1000);
        }
    }
};

$(document).ready([animationsZone2.sliderAndPlane, animationsZone2.searchIcon]);
